export default {
    trainer_applies: [],
    trainer_apply: null,
    trainer: null,
};



// WEBPACK FOOTER //
// ./src/store/trainer_apply/state.js